import { render } from "./OuterPasswordEditPage.vue?vue&type=template&id=3634e8ec&scoped=true&ts=true"
import script from "./OuterPasswordEditPage.vue?vue&type=script&lang=ts"
export * from "./OuterPasswordEditPage.vue?vue&type=script&lang=ts"

import "./OuterPasswordEditPage.vue?vue&type=style&index=0&id=3634e8ec&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src93515913/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3634e8ec"]])

export default __exports__